"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.easeOutSine = exports.easeOutQuint = exports.easeOutQuart = exports.easeOutQuad = exports.easeOutExpo = exports.easeOutCubic = exports.easeOutCirc = exports.easeOutBack = exports.easeInSine = exports.easeInQuint = exports.easeInQuart = exports.easeInQuad = exports.easeInOutSine = exports.easeInOutQuint = exports.easeInOutQuart = exports.easeInOutQuad = exports.easeInOutExpo = exports.easeInOutCubic = exports.easeInOutCirc = exports.easeInOutBack = exports.easeInExpo = exports.easeInCubic = exports.easeInCirc = exports.easeInBack = void 0;
/**
 * Easing shortcuts. Originally brought over from LoL styles and can be absorbed into themes in the future
 */
var easeInSine = "cubic-bezier(0.470, 0.000, 0.745, 0.715)";
exports.easeInSine = easeInSine;
var easeOutSine = "cubic-bezier(0.390, 0.575, 0.565, 1.000)";
exports.easeOutSine = easeOutSine;
var easeInOutSine = "cubic-bezier(0.445, 0.050, 0.550, 0.950)";
exports.easeInOutSine = easeInOutSine;
var easeInQuad = "cubic-bezier(0.550, 0.085, 0.680, 0.530)";
exports.easeInQuad = easeInQuad;
var easeOutQuad = "cubic-bezier(0.250, 0.460, 0.450, 0.940)";
exports.easeOutQuad = easeOutQuad;
var easeInOutQuad = "cubic-bezier(0.455, 0.030, 0.515, 0.955)";
exports.easeInOutQuad = easeInOutQuad;
var easeInCubic = "cubic-bezier(0.550, 0.055, 0.675, 0.190)";
exports.easeInCubic = easeInCubic;
var easeOutCubic = "cubic-bezier(0.215, 0.610, 0.355, 1.000)";
exports.easeOutCubic = easeOutCubic;
var easeInOutCubic = "cubic-bezier(0.645, 0.045, 0.355, 1.000)";
exports.easeInOutCubic = easeInOutCubic;
var easeInQuart = "cubic-bezier(0.895, 0.030, 0.685, 0.220)";
exports.easeInQuart = easeInQuart;
var easeOutQuart = "cubic-bezier(0.165, 0.840, 0.440, 1.000)";
exports.easeOutQuart = easeOutQuart;
var easeInOutQuart = "cubic-bezier(0.770, 0.000, 0.175, 1.000)";
exports.easeInOutQuart = easeInOutQuart;
var easeInQuint = "cubic-bezier(0.755, 0.050, 0.855, 0.060)";
exports.easeInQuint = easeInQuint;
var easeOutQuint = "cubic-bezier(0.230, 1.000, 0.320, 1.000)";
exports.easeOutQuint = easeOutQuint;
var easeInOutQuint = "cubic-bezier(0.860, 0.000, 0.070, 1.000)";
exports.easeInOutQuint = easeInOutQuint;
var easeInExpo = "cubic-bezier(0.950, 0.050, 0.795, 0.035)";
exports.easeInExpo = easeInExpo;
var easeOutExpo = "cubic-bezier(0.190, 1.000, 0.220, 1.000)";
exports.easeOutExpo = easeOutExpo;
var easeInOutExpo = "cubic-bezier(1.000, 0.000, 0.000, 1.000)";
exports.easeInOutExpo = easeInOutExpo;
var easeInCirc = "cubic-bezier(0.600, 0.040, 0.980, 0.335)";
exports.easeInCirc = easeInCirc;
var easeOutCirc = "cubic-bezier(0.075, 0.820, 0.165, 1.000)";
exports.easeOutCirc = easeOutCirc;
var easeInOutCirc = "cubic-bezier(0.785, 0.135, 0.150, 0.860)";
exports.easeInOutCirc = easeInOutCirc;
var easeInBack = "cubic-bezier(0.600, -0.280, 0.735, 0.045)";
exports.easeInBack = easeInBack;
var easeOutBack = "cubic-bezier(0.175, 0.885, 0.320, 1.275)";
exports.easeOutBack = easeOutBack;
var easeInOutBack = "cubic-bezier(0.680, -0.550, 0.265, 1.550)";
exports.easeInOutBack = easeInOutBack;